import type { FC } from 'react';

import { HelpCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@repo/ui/components/common';

import { ExternalLink } from '@/components/common/ExternalLink';
import { SIPLogoLink } from '@/components/common/SIPLogoLink';

export const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="bg-secondary flex py-8 text-white">
        <div className="container mx-auto flex flex-col items-start justify-between gap-4 px-6 max-xl:max-w-none md:flex-row md:gap-8">
          <SIPLogoLink className="shrink-0" />
          <div className="flex flex-1 flex-col gap-2 md:max-w-4xl">
            <p>{t('footer.info')}</p>
            <p>{t('footer.informationProvided')}</p>
            <p>{t('footer.contactDealer')}</p>
          </div>
          <Button asChild variant="ghost">
            <ExternalLink href={t('footer.helpUrl')} ariaLabel={t('footer.help')}>
              <HelpCircleIcon className="size-6" />
            </ExternalLink>
          </Button>
        </div>
      </div>
    </footer>
  );
};
